export default __webpack_public_path__ + "static/media/bulgo-mobile-2.76add017.png";